import * as fetch from '../fetch'

let RemoveNull = (obj)=>{
	for(let key in obj){
		if(obj[key] === null || obj[key] === undefined){
			delete obj[key];
		}
	}
	return obj;
};

export function user_login(data){
	return fetch.main_public_fetch({
		url: '/user/login',
		method: 'post',
		data
	});
}

export function user_forgot(data){
	return fetch.main_public_fetch({
		url: '/user/forgot',
		method: 'post',
		data
	});
}

export function user_logout(data){
	return fetch.main_private_fetch({
		url: '/user/logout',
		method: 'post',
		data
	});
}

export function user_change_profile(data){
	RemoveNull(data);
	return fetch.main_private_fetch({
		url: '/user/change-profile',
		method: 'post',
		data
	});
}

export function user_register(data){
	return fetch.main_public_fetch({
		url: '/user/register',
		method: 'post',
		data
	});
}

export function send_email_code(data){
	return fetch.main_public_fetch({
		url: '/user/send-mail',
		method: 'post',
		data
	});
}

export function user_info(data){
	return fetch.main_private_fetch({
		url: '/user/',
		method: 'get',
		params: data
	})
}

export function get_user_code_list(data){
	return fetch.main_private_fetch({
		url: '/user/codedit',
		method: 'get',
		params: data,
	})
}

export function delete_user_code(data){
	return fetch.main_private_fetch({
		url: '/user/codedit/' + data.id,
		method: 'delete',
		params: data,
	})
}


export function change_public_user_code(data){
	return fetch.main_private_fetch({
		url: '/user/codedit/public/' + data.id,
		method: 'patch',
		params: data,
	});
}

export function save_user_code(data){
	return fetch.main_private_fetch({
		url: '/user/codedit',
		method: 'post',
		data: data,
	});
}

export function get_user_code(data){
	let hash = data.hash;
	delete data['hash'];

	return fetch.main_public_fetch({
		url: '/user/codedit/hash/' + hash,
		method: 'get',
		params: data,
	})
}

export function get_user_server_list(data){
	return fetch.main_private_fetch({
		url: '/user/server',
		method: 'get',
		params: data,
	})
}

export function create_user_server(data){
	return fetch.main_private_fetch({
		url: '/user/server',
		method: 'post',
		data,
	})
}

export function save_user_server(data){
	return fetch.main_private_fetch({
		url: '/user/server/' + data.server_id,
		method: 'patch',
		data,
	})
}

export function get_user_server(data){
	return fetch.main_private_fetch({
		url: '/user/server/' + data.id,
		method: 'get',
		params: data,
	})
}

export function get_user_markdown(data){
	return fetch.main_private_fetch({
		url: '/user/markdown',
		method: 'get',
		params: data,
	})
}

export function get_code_share_link_anonymous(data){
	return fetch.main_public_fetch({
		url: '/codedit/share',
		method: 'post',
		data,
	})
}


export function get_code_share_link_auth(data){
	return fetch.main_private_fetch({
		url: '/user/codedit/share',
		method: 'post',
		data,
	})
}
